import { useAccountId } from "./useAccountId";
import { useAwaitValue } from "./useAwaitValue";

export const useAwaitAccountId = async (accountId?: number) : Promise<number> => {
  const aId = await useAwaitValue(useAccountId(accountId), 'aId');
  if (!aId) throw new Error('Could not aquire account id!');
  return aId;
};
